import { Button } from 'antd';
import { useContext } from 'react';
import { AIEditContext } from '../../AIEditContext';
import Utils from '@utils/utils';
import styles from '../fillLightBar/index.module.scss'

const ImageFinerBar = (props) => {
    const { AIEditLoading } = useContext(AIEditContext)

    const createClick = async () => {
        if (!props.url) return
        const status = Utils.checkLoginStatus(() => createClick())
        if (!status) return

        props.createClick()
    }

    return (
        <div className={styles.FillLight}>
            <div className={`${styles.FillLightContent} ${!props.url && styles.disabled}`}>
                <Button
                    type="primary"
                    loading={AIEditLoading}
                    disabled={!props.url}
                    className={styles.createBtn}
                    onClick={createClick}
                >
                    应用改动
                    <img src={require('@assets/images/arcbean3.png')} />
                    <span className={styles.beanNum}>5</span>
                </Button>
            </div>
        </div>
    )
}

export default ImageFinerBar
